module.exports = __webpack_public_path__ + "static/img/ai_but.e110eb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ai_but.png
// module id = brpy
// module chunks = 1